import { List } from '@mui/material';
import { useEntitySearch } from 'api/entity';
import React from 'react';

import { SearchResultEntityListItems } from '../components/entityList';
import { SearchResultsLoader } from '../components/loader';
import { SearchQuery } from '../processQuery';

export function SearchGlobal(props: {
  value: SearchQuery;
  onClick: (open: boolean) => void;
}) {
  const { value, onClick: setOpen } = props;

  const { data, isLoading } = useEntitySearch(value.queryText);

  if (isLoading) {
    return <SearchResultsLoader />;
  }

  return (
    <List disablePadding>
      <SearchResultEntityListItems entities={data ?? []} onClick={setOpen} />
    </List>
  );
}
